import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

export default class StopPropagationController extends Controller {
  stop (event) {
    event.stopPropagation()
  }
}

stimulus.register('stop-propagation', StopPropagationController)
